import { render, staticRenderFns } from "./CmgGroupOrderJoin.vue?vue&type=template&id=3fd89026&scoped=true&lang=pug"
import script from "./cmg-group-order-join.ts?vue&type=script&lang=ts&external"
export * from "./cmg-group-order-join.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgGroupOrderJoin.vue?vue&type=style&index=0&id=3fd89026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd89026",
  null
  
)

export default component.exports